export const breakpoints = {
  tablet: '48em', // 768px
  desktop: '64em', // 1024px
} as const;

export type Breakpoint = 'mobile' | 'tablet' | 'desktop';
